module.exports = __webpack_public_path__ + "img/step49.d3f0ff95.png";